<template>
    <div class="row">
        <div class="col-md-12">
            <card>
                <template slot="header">
                    <div
                        v-if="['activity', 'registration'].includes($route.params.type)"
                        class="d-flex justify-content-center">
                            <el-switch
                                v-model="accept"
                                active-text="Accept Registrant"
                                inactive-text="Deny Registrant"
                                disabled/>
                    </div>
                    <br>
                    <div style="text-align: center;">{{activityDetails.name}}</div>
                </template>
                <!-- <qrcode-stream @decode="onDecode"/> -->
                <qrcode-stream :camera="camera" @decode="onDecode" :track="paintOutline" @init="onInit"/>
                
                <div class="d-flex justify-content-center">
                    <el-select v-model="camera" clearable placeholder="Select">
                        <el-option 
                            v-for="(cam, index) in cameras"  
                            :key="cam.deviceId"          
                            @click="switchCamera(cam.deviceId)"      
                            :label="'Camera '+ (index+1)"
                            :value="cam.deviceId">
                        </el-option>
                        <el-option        
                            @click="switchCamera('rear')"      
                            label="Main Rear Camera"
                            value="rear">
                        </el-option>
                    </el-select>
                </div>
            </card>
        </div>

        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="showResultModal">
            <div style="flex-direction: column;" class="d-flex align-items-center justify-content-center">
                <svg v-if="result.reason == 'checked-in'" class="result-icon success" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
                <svg v-else-if="result.reason == 'already-checked-in'" class="result-icon warning" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                </svg>
                <svg v-else class="result-icon error" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
                <p style="font-size: 1.2rem; margin-top: 10px; text-align: center;">{{ result.message }}</p>
                <template #footer>
                    <el-button @click="showResultModal = false" class="btn btn-primary" style="width:100%">Okay</el-button>
                </template>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import swal from 'sweetalert2'
// import QrcodeStream from '@/components/scanner/QrcodeStream'
// import QrcodeDropZone from '@/components/scanner/QrcodeDropZone'
// import QrcodeCapture from '@/components/scanner/QrcodeCapture'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from '@jyotirmay/vue-qrcode-reader-extended'
import http from '../http.js'
import { mapState } from 'vuex'


export default {
    components: {
        QrcodeStream,
        QrcodeDropZone,
        QrcodeCapture
    },
    data () {
        return {
            accept: true,
            method: 'qr',
            activityDetails: {},
            camera:"rear",
            cameras:[],
            stream: null,
            showResultModal: false,
            result: {
                reason: "",
                message: ""
            }
        }
    },
    async mounted(){
        this.getActivityDetails();
        // get permissions first
        this.stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: true,
        })
        const devices = await navigator.mediaDevices.enumerateDevices()
        this.cameras = devices.filter((device) => ["videoinput"].includes(device.kind));
    },

    async destroyed(){
        await this.stopMediaStram();
    },
    computed: {
        ...mapState([
            'user',
            'event'
        ])
    },
    methods: {
        async stopMediaStram(){
            if(this.stream){
                this.stream.getTracks().forEach(track => track.stop())
            }
        },
        getActivityDetails : async function(){
            const response = await http.get(`api/activities/${this.$route.params.id}`)
            if(response.data && Object.keys(response.data).length){
                this.activityDetails = response.data.activity
                if(!this.activityDetails.scanEnabled){
                    this.$router.push({ name: 'forbidden', params: { eventId: this.$route.params.eventId } })
                }
            }
        },
        onDecode: async function (decodedString) {
            if (!decodedString || !decodedString.length) {
                return
            }

            try {
                const response = await this.$store.dispatch('checkin', {
                    type: this.$route.params.type,
                    id: this.$route.params.id,
                    registrationId: decodedString,
                    accept: this.accept,
                    method: this.method,
                    checkinBy: this.user,
                    eventId: this.event._id,
                })
                const registration = response.data.registration
                //console.log('@@registration', this.event, registration)
                let firstName = ''

                if (registration) {
                    firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
                    firstName = firstName ? firstName.value : ''
                }

                // this.$notify(`User ${firstName} successfully checked in!`)
                this.result = {
                    reason: 'checked-in',
                    message: `User ${firstName} successfully checked in!`
                }

            } catch (e) {
                if(e.response.data.reason == 'already-checked-in'){
                    this.result.reason = 'already-checked-in'
                    this.result.message = 'User '+e.response.data.message;
                }else{
                    this.result.reason = 'not-registered'
                    this.result.message = 'User '+e.response.data.message;
                }
            }

            this.showResultModal = true;

        },
        async onInit (promise) {
            try {
                await promise
            } catch (error) {
                console.error(error)
            }
        },
        paintOutline (detectedCodes, ctx) {
            for (const detectedCode of detectedCodes) {
                const [ firstPoint, ...otherPoints ] = detectedCode.cornerPoints
                ctx.strokeStyle = "red";
                ctx.beginPath();
                ctx.moveTo(firstPoint.x, firstPoint.y);
                for (const { x, y } of otherPoints) {
                ctx.lineTo(x, y);
                }
                ctx.lineTo(firstPoint.x, firstPoint.y);
                ctx.closePath();
                ctx.stroke();
            }
        },
        async switchCamera (deviceId) {
            this.error = false;
            this.camera = deviceId;
        },
    }
}
</script>

<style scoped>
.result-icon{
    height: 100px;
    width: 100px;
}
.success{
    color: rgb(7, 216, 0);
}
.error{
    color: rgb(216, 0, 0);
}
.warning{
    color: rgb(221, 203, 4);
}
</style>